// extracted by mini-css-extract-plugin
export var container = "_2a-0";